import I18n from 'I18n';
export function formatDuration(ms) {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor(ms % 60000 / 1000);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}
export function formatDurationLongString(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const parts = [];
  if (hours > 0) {
    parts.push(`${hours} ${I18n.text('videoData.time.abbreviations.hour')}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${I18n.text('videoData.time.abbreviations.minute')}`);
  }
  if (seconds > 0 && hours === 0) {
    parts.push(`${seconds} ${I18n.text('videoData.time.abbreviations.second')}`);
  }
  return parts.length > 0 ? parts.join(' ') : `0 ${I18n.text('videoData.time.abbreviations.second')}`;
}